import { Box, Image, Theme, Typography } from "@outschool/backpack";
import { measurePerformance } from "@outschool/ui-analytics";
import React from "react";

import CardHeading from "./CardHeading";
import CardLink from "./CardLink";

/** Parent dashboard card that displays a title and image */
export default function HeroCard({
  id,
  title,
  imageUrl,
  showImageOnTop = false,
  url,
  trackingProperties,
  subtitle = null
}: $TSFixMe) {
  return (
    <CardLink url={url} id={id} trackingProperties={trackingProperties}>
      <Box
        flex
        sx={{
          color: "common.black",
          borderRadius: "1em",
          textAlign: "center",
          boxShadow: "0 4px 24px rgba(0, 0, 0, 0.12)",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "214px"
        }}
      >
        {showImageOnTop && (
          <Image
            onLoad={() => {
              // Captures the page load performance of the home page
              measurePerformance("os-page-load", {
                source: "hero-card-image",
                variant: "parent-dashboard-v1-5",
                imageOnTop: true
              });
            }}
            sx={{
              width: "100%",
              borderTopLeftRadius: "1em",
              borderTopRightRadius: "1em",
              objectFit: "cover"
            }}
            src={
              imageUrl ||
              "https://images.pexels.com/photos/7130469/pexels-photo-7130469.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=300"
            }
          />
        )}
        {subtitle && <CardHeading title={title} subtitle={subtitle} />}
        <Typography
          variant="h3"
          sx={(theme: Theme) => ({
            fontFamily: "'Ginto Normal',sans-serif",
            fontSize: `${theme.typography.pxToRem(16)} !important`,
            lineHeight: "24px",
            textAlign: "left",
            paddingLeft: "16px",
            paddingRight: "16px",
            paddingTop: "12px"
          })}
        >
          {title}
        </Typography>

        {!showImageOnTop && (
          <Image
            onLoad={() => {
              // Captures the page load performance of the home page
              measurePerformance("os-page-load", {
                source: "hero-card-image",
                variant: "parent-dashboard-v1-5",
                imageOnTop: false
              });
            }}
            sx={{
              height: "142px",
              width: "100%",
              borderBottomLeftRadius: "1em",
              borderBottomRightRadius: "1em",
              objectFit: "cover"
            }}
            src={
              imageUrl ||
              "https://images.pexels.com/photos/7130469/pexels-photo-7130469.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=300&w=300"
            }
          />
        )}
      </Box>
    </CardLink>
  );
}
